/**
 * Values handed to the bundle by wp_localize_script() in functions.php.
 *
 * The nonce is sent when present, but the REST endpoints these islands call are
 * public and must NOT require it: WP Engine serves anonymous visitors from full
 * page cache, so a cached page carries a nonce minted for a different (or
 * already-expired) session. Requiring it would fail submissions for exactly the
 * visitors we are trying to capture. Spam control is the honeypot plus
 * server-side rate limiting, as in the Supabase build.
 */
export interface OzriaConfig {
  restUrl: string;
  nonce?: string;
}

declare global {
  interface Window {
    ozriaConfig?: OzriaConfig;
  }
}

export const config = (): OzriaConfig =>
  window.ozriaConfig ?? { restUrl: "/wp-json/ozria/v1/" };

/** POST JSON to an ozria/v1 REST route. Throws on any non-2xx. */
export async function postRest<T = unknown>(
  route: string,
  body: unknown
): Promise<T> {
  const { restUrl, nonce } = config();

  const response = await fetch(restUrl.replace(/\/?$/, "/") + route, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      ...(nonce ? { "X-WP-Nonce": nonce } : {}),
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`${route} responded ${response.status}`);
  }

  return (await response.json()) as T;
}
